//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import i18n from '@/utils/i18n';
import containerMixin from '@/components/form-designer/form-widget/container-widget/containerMixin';
import ContainerWrapper from '@/components/form-designer/form-widget/container-widget/container-wrapper';
import TableCellWidget from '@/components/form-designer/form-widget/container-widget/table-cell-widget';
import refMixinDesign from '@/components/form-designer/refMixinDesign';
export default {
  name: 'table-widget',
  componentName: 'ContainerWidget',
  mixins: [i18n, containerMixin, refMixinDesign],
  inject: ['refList'],
  components: {
    ContainerWrapper: ContainerWrapper,
    TableCellWidget: TableCellWidget
  },
  props: {
    widget: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object
  },
  computed: {
    selected: function selected() {
      return this.widget.id === this.designer.selectedId;
    },
    customClass: function customClass() {
      return this.widget.options.customClass || '';
    }
  },
  watch: {
    //
  },
  created: function created() {
    this.initRefList();
  },
  mounted: function mounted() {
    //
  },
  methods: {}
};